import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Result } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { ROUTES } from "common/constants/routes";
import { Loader } from "shared/components/Components";

const LogoutPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);
  const reason = params.get("reason");
  useEffect(() => {
    if (reason === "error") {
      navigate(ROUTES.MAIN, { replace: true });
    }
  }, [reason, navigate]);

  if (reason === "error") {
    return <Loader animate={true} logo={true} title={"Redirecting..."} />;
  }

  return (
    <Result
      title="Logged out"
      icon={
        <ExclamationCircleOutlined style={{ fontSize: 48, color: "#e60054" }} />
      }
      subTitle="You have successfully logged out of Mercury"
      extra={<a href={ROUTES.MAIN}>Log in</a>}
    />
  );
};

export default LogoutPage;
